
const DirectionalLight = {
  schema: {
    lightType: { label: 'type', type: 'String', defaultValue: 'DirectionalLight' },
    color: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
    intensity: { label: 'Intensity', type: 'Number', defaultValue: 0.8 },
  },
};

const SpotLight = {
  schema: {
    lightType: { label: 'type', type: 'String', defaultValue: 'SpotLight' },
    color: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
    intensity: { label: 'Intensity', type: 'Number', defaultValue: 0.8 },
  },
};

const PointLight = {
  schema: {
    lightType: { label: 'type', type: 'String', defaultValue: 'PointLight' },
    color: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
    intensity: { label: 'Intensity', type: 'Number', defaultValue: 0.8 },
  },
};

const HemisphereLight = {
  schema: {
    lightType: { label: 'type', type: 'String', defaultValue: 'HemisphereLight' },
    color: { label: 'Sky Color', type: 'Color', defaultValue: { r: 0.2, g: 0.52, b: 1 } },
    gndColor: { label: 'Sky Color', type: 'Color', defaultValue: { r: 1, g: 0.78, b: 0.5 } },
    intensity: { label: 'Intensity', type: 'Number', defaultValue: 0.6 },
  },
};

const AreaLight = {
  schema: {
    lightType: { label: 'type', type: 'String', defaultValue: 'AreaLight' },
    color: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
    intensity: { label: 'Intensity', type: 'Number', defaultValue: 10 },
  },
};

export default { DirectionalLight, SpotLight, PointLight, HemisphereLight, AreaLight };



// WEBPACK FOOTER //
// ./src/operators/Light.js